import { API_AUTH } from "./common";

const DanhSachThanhLyApi = {
  // list: ({
  //   dateFrom,
  //   dateTo,
  //   code,
  //   customerName,
  //   address,
  //   noteTaiSan,
  //   status,
  //   debt,
  //   userName,
  //   pageIndex,
  //   pageSize,
  // }) =>
  //   API_AUTH.get(
  //     `quanlytaisan/danh-sach-thanh-ly?dateFrom=${dateFrom}&dateTo=${dateTo}&code=${code}&customerName=${customerName}&address=${address}&noteTaiSan=${noteTaiSan}&status=${status}&debt=${debt}&userName=${userName}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
  //     {}
  //   ),
  list: ({ customerName, pageIndex, pageSize }) =>
    API_AUTH.get(
      `quan-ly-tai-san/danh-sach-thanh-ly?customerName=${customerName}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    ),
  list1: ({
    customerName,
    taisanCode,
    hopdongCode,
    tuNgay,
    denNgay,
    pageIndex,
    pageSize,
  }) =>
    API_AUTH.get(
      `quan-ly-tai-san/danh-sach-thanh-ly-1?customerName=${customerName}&taisanCode=${taisanCode}&hopdongCode=${hopdongCode}&tuNgay=${tuNgay}&denNgay=${denNgay}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    ),
  phanquyenDanhSachThanhLy: () =>
    API_AUTH.get(`quan-ly-tai-san/phan-quyen-danh-sach-thanh-ly`, {}),
  getInDanhSachThanhLy: (
    customerName,
    taisanCode,
    hopdongCode,
    tuNgay,
    denNgay
  ) =>
    API_AUTH.get(
      `quan-ly-tai-san/in-danh-sach-thanh-ly?customerName=${customerName}&taisanCode=${taisanCode}&hopdongCode=${hopdongCode}&tuNgay=${tuNgay}&denNgay=${denNgay}`,
      {}
    ),
  getInThanhToanThanhLyTaiSan: (thanhLyId) =>
    API_AUTH.get(
      `quan-ly-tai-san/in-thanh-toan-thanh-ly-tai-san?thanhLyId=${thanhLyId}`,
      {}
    ),
};

export default DanhSachThanhLyApi;
